import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('../../security/interceptors')

const all = () => {
    return api.get(`/campaigns/all`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar as campanhas')
        })
}

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/campaigns?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de campanhas')
        })
}

const find = (id) => {
    return api.get(`/campaigns/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a campanha')
        })
}

const findByCompanie = (id) => {
    return api.get(`/campaigns/bycompany/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar as campanhas da empresa')
        })
}

const store = (data) => {
    return api.post(`/campaigns`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível criar a campanha')
        })
}

const update = (data) => {
    return api.put(`/campaigns`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar a campanha')
        })
}

const destroy = (id) => {
    return api.delete(`/campaigns/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir a campanha')
        })
}

const status = (id) => {
    return api.get(`/campaigns/status/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os status da campanha')
        })
}

const contacts = (id, page) => {
    return api.get(`/campaigns/${id}/contacts`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os contatos da campanha')
        })
}

const validateTotalContacts = (data) => {
    return api.post(`/campaigns/validatetotalcontacts`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível validar a quantidade de contatos')
        })
}

const validateMessage = (data) => {
    return api.post(`/misc/validatemessage`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível validar a mensagem')
        })
}

export default {
    all,
    findAll,
    find,
    findByCompanie,
    store,
    update,
    destroy,
    status,
    contacts,
    validateTotalContacts,
    validateMessage
}
